<footer class="footer">
  <div class="max-width">
    <div class="col-xs-6 col-md-4 min-padding">
      <ul>
        <li>Lösungen</li>
        <li><a href="https://www.edr-software.com/loesungen/maengelmanagement/" target="_blank">Mängelmanagement</a></li>
        <li><a href="https://www.edr-software.com/loesungen/bildmanagement/" target="_blank">Bildmanagement</a></li>
        <li><a href="https://www.edr-software.com/loesungen/baudokumentation/" target="_blank">Baudokumentation</a></li>
        <li><a href="https://www.edr-software.com/loesungen/integration/" target="_blank">Integration</a></li>
        <li><a href="https://www.edr-software.com/loesungen/dokumentenmanagement/" target="_blank">Dokumentenmanagement</a></li>
      </ul>
    </div>
    <div class="col-xs-6 col-md-4 min-padding">
      <ul>
        <li>Services</li>
        <li><a href="https://www.edr-software.com/services/beratung/" target="_blank">Beratung</a></li>
        <li><a href="https://www.edr-software.com/services/konfigurations-service/" target="_blank">Konfigurations-Service</a></li>
        <li><a href="https://www.edr-software.com/services/schulung/" target="_blank">Schulung</a></li>
        <li><a href="https://www.edr-software.com/services/helpdesk-service/" target="_blank">Helpdesk-Service</a></li>
        <li><a href="https://www.edr-software.com/services/implementierung/" target="_blank">Software as a Service</a></li>
      </ul>
    </div>
    <div class="col-xs-6 col-md-4 min-padding">
      <ul>
        <li>Kontakt</li>
        <li>edr software GmbH</li>
        <li>Zweibrückenstraße 5-7</li>
        <li>D-80331 München</li>
        <li><a class="phone-link" href="tel:004989540234820">+49 (0) 89 540 23 48–20</a></li>
        <li><a class="email-link" href="mailto:info@edr-software.com">info@edr-software.com</a></li>
        <li><a class="route-link" href="https://www.google.de/maps/place/edr+software+GmbH+%E2%80%93+Bausoftware/@48.133366,11.5809054,17z/data=!3m2!4b1!5s0x479e75f455e9ac0f:0xa20e12ab2f84095f!4m6!3m5!1s0x479dd8a3086d2917:0x349215e90e9d7646!8m2!3d48.133366!4d11.5834857!16s%2Fg%2F1vknnb_t?entry=ttu" target="_blank">Google Maps</a></li>
      </ul>
    </div>
    <!-- <div class="col-xs-6 col-md-offset-4 col-md-4 min-padding">
      <ul>
        <li>Follow us</li>
        <li><a href="https://www.facebook.com/EDRSoftware/?fref=ts" target="_blank"><span class="edr-icon-social edr-icon-social-g edr-icon-social-fb-g"></span></a></li>
        <li><a href="https://www.youtube.com/user/edrprojekt/" target="_blank"><span class="edr-icon-social edr-icon-social-g edr-icon-social-yt-g"></span></a></li>
        <li><a href="https://www.xing.com/companies/edrsoftwaregmbh/" target="_blank"><span class="edr-icon-social edr-icon-social-g edr-icon-social-xing-g"></span></a></li>
      </ul>
    </div> -->
    <div class="col-xs-6 col-md-4 min-padding">
      <ul>
        <li></li>
        <li><a href="https://www.edr-software.com/impressum/" target="_blank">Impressum</a></li>
      </ul>
    </div>

    <div class="col-xs-6 col-md-4 min-padding">
      <ul>
        <li></li>
        <li><a href="https://www.edr-software.com/datenschutzerklaerung/" target="_blank">Datenschutzerklärung</a></li>
      </ul>
    </div>

    <div class="col-xs-6 col-md-4 min-padding">
      <ul>
        <li></li>
        <li><p>© <strong>edr software GmbH</strong></p></li>
      </ul>
    </div>
  </div>
</footer>

